<table class="table facturas-table" style="margin: 15px 0;">
    <thead>
        <tr>
            <th colspan="7">Productos Facturados</th>
        </tr>
        <tr>
            <th>Factura</th>
            <th>Fecha</th>
            <th>Producto</th>
            <th>Lote</th>
            <th>Cantidad</th>
            <th>Registrados</th>
            <th>Accion</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let producto of productos">
            <!-- fila encabezado de la factura -->
            <tr class="factura-header"
                [class.factura-completada]="producto.cantidad_productos==producto.trazabilidad_productos.length">
                <td>{{ producto.factura.numero_factura }}</td>
                <td>{{ producto.factura.fecha | date: 'dd/MM/YYYY'}}</td>
                <td>{{ producto.tipo_producto.descripcion }}</td>
                <td>{{ producto.lote }}</td>
                <td>{{ producto.cantidad_productos }}</td>
                <td>
                    Productos ({{ producto.trazabilidad_productos.length}})
                </td>
                <td style="text-align: center;">
                    <a [routerLink]="['/trazabilidad', producto.id]"><i class="pi pi-pencil"
                            style="font-size: 1.2rem"></i></a>
                </td>
            </tr>
        </ng-container>
        <ng-container *ngIf="productos.length==0">
            <tr>
                <td colspan="7" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">Sin registro de productos facturados</span>
                    </div>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>